import { Header } from '../Header';
import { Footer } from '../Footer';

interface PageLayoutProps {
  hero: React.ReactNode;
  game: React.ReactNode;
  children?: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ hero, game, children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {hero}
        <div className="max-w-4xl mx-auto px-6 py-8">
          {game}
          {children && <div className="mt-6">{children}</div>}
        </div>
      </main>
      <Footer />
    </div>
  );
};